import { axiosInstance } from "@/api/apiClient";
import {
  TeamMembersApi,
  TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembersRequest,
  TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitationRequest,
  TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmailRequest,
  TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitationsRequest,
  TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbersRequest,
  TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberRequest,
  TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberV2Request,
  TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersV2Request,
  TeamMembersApiTelephonyViewsNinjaTeamTeamMemberNudgeTeamMemberRequest,
  TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfileRequest,
  TeamMembersApiUsersViewsNinjaBusinessListPermissionRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new TeamMembersApi(undefined, BASE_API, axiosInstance);

export const updateTeamMemberProfile = async (
  payload: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfileRequest
) => {
  return api.telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile.bind(api)(
    payload
  );
};

export const getTeamMember = async (
  payload: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberRequest
) => {
  return api.telephonyViewsNinjaTeamTeamMemberGetTeamMember.bind(api)(payload);
};

export const getTeamMembersV2 = async (
  payload: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersV2Request
) => {
  return api.telephonyViewsNinjaTeamTeamMemberListTeamMembersV2.bind(api)(
    payload
  );
};

export const getTeamMemberV2 = async (
  payload: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberV2Request
) => {
  return api.telephonyViewsNinjaTeamTeamMemberGetTeamMemberV2.bind(api)(
    payload
  );
};

export const nudgeTeamMember = async (
  payload: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberNudgeTeamMemberRequest
) => {
  return api.telephonyViewsNinjaTeamTeamMemberNudgeTeamMember.bind(api)(
    payload
  );
};

export const createTeamMembers = async (
  payload: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembersRequest
) => {
  return api.telephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembers.bind(api)(
    payload
  );
};

export const getPermissions = async (
  payload: TeamMembersApiUsersViewsNinjaBusinessListPermissionRequest
) => {
  return api.usersViewsNinjaBusinessListPermission.bind(api)(payload);
};

export const inviteTeamMembers = async (
  payload: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitationRequest
) => {
  return api.telephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitation.bind(
    api
  )(payload);
};

export const checkTeamMemberByEmail = async (
  payload: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmailRequest
) => {
  return api.telephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmail.bind(api)(
    payload
  );
};

export const getTeamMemberInvitations = async (
  payload: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitationsRequest
) => {
  return api.telephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations.bind(
    api
  )(payload);
};

export const getTeamMemberReceiverNumbers = async (
  payload: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbersRequest
) => {
  return api.telephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbers.bind(
    api
  )(payload);
};
